<section class="approver-container">
  <span>Approvers</span>

  <div class="sub-container">
    <div class="header-row">
      <span>Name, Title</span>
      <span style="padding-right: 7rem">DOA Authority Amount</span>
    </div>
    <div
      *ngFor="let approver of (approverList || []); let i = index"
      class="approver-row"
    >
      <mat-form-field class="approver-input">
        <input
          [name]="autocompleteName(i)"
          type="text"
          matAutocompletePosition="below"
          matInput
          [matAutocomplete]="auto1"
          [formControl]="additionalApproverControl[i]"
          [(ngModel)]="additionalApprovers[i]"
          (keydown.enter)="
            $event.stopPropagation();
            searchUsersAdditionalApprover($event.target.value, i)
          "
          required
          [name]="'additionalApprover' + i"
          [disabled]="reviewMode"
        />

        <div
          *ngIf="additionalApprovers[i] && additionalApprovers[i].displayName && !reviewMode"
          style="z-index: 0; position: absolute; right: 4px; top: 5px"
        >
          <img
            (click)="deleteAdditionalApproverValue(i)"
            style="cursor: pointer"
            src="assets/close-window.svg"
          />
        </div>
      </mat-form-field>
      <mat-autocomplete
        #auto1="matAutocomplete"
        [displayWith]="displayFnAdditionalApprover"
        (optionSelected)="additionalApproverSelected($event.option.value, i)"
      >
        <mat-option
          *ngFor="let option of additionalApproverOptions[i]"
          style="color: #696969"
          [value]="option"
        >
          <span *ngIf="option.givenName && option.surname && option.jobTitle"
            >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
            {{ option.jobTitle }}</span
          >
          <span *ngIf="option.givenName && option.surname && !option.jobTitle"
            >{{ option.givenName }} {{ option.surname }} ({{
              option.mail
            }})</span
          >
          <span *ngIf="!(option.givenName && option.surname) && option.jobTitle"
            >{{ option.displayName }} ({{ option.mail }}),
            {{ option.jobTitle }}</span
          >
          <span
            *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
            >{{ option.displayName }} ({{ option.mail }})</span
          >
        </mat-option>
      </mat-autocomplete>

      <button
        *ngIf="!reviewMode"
        class="button-primary"
        style="width: 5rem !important"
        type="button"
        (click)="searchUsersAdditionalApprover(additionalApprovers[i], i)"
      >
        <span class="confirmText">SEARCH</span>
      </button>

      <span
        *ngIf="!doaLookupFailed[i + 1] && !doaLookupLoading[i + 1]"
        style="width: 17%; text-align: center;"
        >${{
          (doaAmounts[i + 1] || 0).toLocaleString("en", { useGrouping: true })
        }}</span
      >
      <span
        *ngIf="doaLookupLoading[i + 1]"
        style="width: 17%; text-align: center; color: #696969; font-size: 0.75rem;"
      >
        Checking DOA&hellip;
      </span>
      <span
        *ngIf="doaLookupFailed[i + 1] && !doaLookupLoading[i + 1]"
        style="width: 17%; text-align: center; color: #9e1b32; font-size: 0.75rem;"
      >
        DOA lookup failed
        <br />
        <a
          style="cursor: pointer; text-decoration: underline;"
          (click)="retryDoaLookup(i + 1)"
          >Retry</a
        >
      </span>

      <img
        *ngIf="!reviewMode"
        style="
          cursor: pointer;
          width: 1rem;
          height: 1rem;
          position: relative;
          top: -1px;
        "
        src="assets/trash-bin-base.svg"
        (click)="deleteApprover(i)"
      />
    </div>

    <div
      *ngIf="(approverList || []).length > 0 && !doaAmountMet()"
      style="padding-left: 1.5rem; background-color: #f3fafd"
    >
      <div style="width: 31rem">
        <span style="color: #9e1b32; font-size: 0.875rem"
          >Warning: DOA amount is not high enough. Please add approver.</span
        >
      </div>
    </div>
    <div class="add-approver-section" (click)="addNewAdditionalApprover()" *ngIf="!reviewMode">
      <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
      <span
        style="
          padding-left: 0.2rem;
          text-decoration: underline;
          text-underline-offset: 0.2rem;
        "
        >Add Another Approver</span
      >
    </div>
  </div>
</section>
